module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/d92e10eba842e58786193b04aa50c9fc.png";